// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_DesvincularComboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/desvincular_combo/{item_id}
 *
 * O item descoberto, a liberacao gravada (0 quando a reserva ja nao estava
 * aberta — OS cancelada) e o saldo da compra DEPOIS dela.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_DesvincularComboResponseDados {
item_id: number
combo_purchase_id: number
movement_id: number
quantidade: number
reservado: number
consumido: number
disponivel: number
}

export type Orders_DesvincularComboResponse = ApiResponse<Orders_DesvincularComboResponseDados>;

registerResponseContract('Orders_DesvincularComboResponse', {
  item_id:           { type: 'number',  required: true },
  combo_purchase_id: { type: 'number',  required: true },
  movement_id:       { type: 'number',  required: true },
  quantidade:        { type: 'number',  required: true },
  reservado:         { type: 'number',  required: true },
  consumido:         { type: 'number',  required: true },
  disponivel:        { type: 'number',  required: true },
})
